import { message } from 'antd'
import { Outlet } from 'react-router-dom'

export const EditorLayout = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [__, contextHolder] = message.useMessage()

  return (
    <>
      {contextHolder}
      <Outlet />
    </>
  )
}
